import { Controller } from 'stimulus'

/**
 * Hotwire flow (Turbo Drive is off in this app, so we load via frame src):
 * 1. First "More" click — set the empty turbo-frame's src to the show URL.
 * 2. turbo:frame-load — expand the card (hides More; Show less is in the loaded footer).
 * 3. Later clicks — toggle visibility only; no second request.
 */
export default class extends Controller {
  static targets = ['frame']
  static values = { loaded: Boolean, frameId: String }

  connect() {
    this.onFrameLoad = this.onFrameLoad.bind(this)
    const frame = this.frameElement
    if (frame) {
      frame.addEventListener('turbo:frame-load', this.onFrameLoad)
    }
  }

  disconnect() {
    const frame = this.frameElement
    if (frame) {
      frame.removeEventListener('turbo:frame-load', this.onFrameLoad)
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.loadedValue) {
      this.setExpanded(!this.element.classList.contains('is-expanded'))
      return
    }

    const frame = this.frameElement
    if (!frame) return

    frame.src = event.currentTarget.href
  }

  onFrameLoad() {
    this.loadedValue = true
    this.setExpanded(true)
  }

  setExpanded(expanded) {
    this.element.classList.toggle('is-expanded', expanded)
  }

  get frameElement() {
    if (this.hasFrameTarget) {
      return this.frameTarget
    }

    if (this.hasFrameIdValue) {
      return document.getElementById(this.frameIdValue)
    }

    return this.element.querySelector('turbo-frame')
  }
}
